module.exports = __webpack_public_path__ + "img/04.87e9e505.jpg";